// Mobile Menu Module
import Mobilemenu from './modules/Mobilemenu';
// Accordion Module
import Accordion from './modules/Accordion';
// Active Menu Item Module
import Activemenu from './modules/Activemenu';
// Back to Top Button Module
import Totop from './modules/Totop';
// Projects Module
import Projects from './modules/Projects';
// Instantiate Mobile Menu Module
const mobileMenu = new Mobilemenu();
// Instantiate Accordion Module
if(document.querySelector("#banner")) {
    const accordion = new Accordion();
}
// Instantiate Active Menu Item Module
if(document.querySelector("#banner")) {
    const activeMenu = new Activemenu();
}
// Instantiate Back to Top Button Module
const toTop = new Totop();
// Instantiate Projects Module
if(document.querySelector("#banner")) {
    const projects = new Projects();
}